import { Credits, Organisation, OrganisationInvite, OrganisationStats, OrganisationStatType, Transaction } from '@/types/company';
import { api } from './client';
import i18n from '@/i18n';
import { isAxiosError } from 'axios';

export const organisationApi = {

  getAll: async (): Promise<Organisation[]> => {
    const { data } = await api.get(`api/v1/organizations`);
    return data;
  },

  get: async (organizationId: string): Promise<Organisation> => {
    try {
      const { data } = await api.get(`/api/v1/organizations/${organizationId}`);
      return data;
    } catch (error) {
      if (isAxiosError(error) && error.status === 403) {
        window.location.pathname = '/';
        throw error;
      }
    }
  },

  create: async (name: string): Promise<Organisation> => {
    const { data } = await api.post(`/companies`, { name }, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data.company;
  },

  edit: async (organisation: Organisation) => {
    const { data } = await api.put(`/companies/${organisation.id}`, organisation);
    return data.company;
  },

  getCredits: async (organizationId: string): Promise<Credits> => {
    const { data } = await api.get(`/companies/${organizationId}/credits`);
    return data;
  },

  addCredits: async (organizationId: string, credits: number) => {
    const { data } = await api.post(`/companies/${organizationId}/credits`, { credits, lang: i18n.global.locale.value }, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  },

  getTransaction: async (organizationId: string, transactionId: string): Promise<Transaction> => {
    const { data } = await api.get(`/companies/${organizationId}/transactions/${transactionId}`);
    return data.transaction;
  },

  getAllTransactions: async (organizationId: string): Promise<Transaction[]> => {
    const { data } = await api.get(`/companies/${organizationId}/transactions`);
    return data.transactions;
  },

  getTransactionInvoice: async (organizationId: string, transactionId: string) => {
    const { data } = await api.get(`/companies/${organizationId}/transactions/${transactionId}/invoice`);
    return data;
  },

  getStats: async (organizationId: string, statType: OrganisationStatType): Promise<OrganisationStats> => {
    const { data } = await api.get(`/companies/${organizationId}/stats/${statType}`);
    return data;
  },
}